import React, { useEffect, useState } from "react";
import ajaxIssueLog from "../../util/remote/ajaxIssueLog";
import CountUp from "react-countup";

export default function NotHandledLogsCard() {
  const [notHandledNumber, setNotHandledNumber] = useState(false);

  const getNotHandledNumber = async () => {
    const server_response = await ajaxIssueLog.fetchNotHandledIssueLogs();
    if (server_response.status === "OK") {
      setNotHandledNumber(server_response.details);
    } else {
      setNotHandledNumber("404");
    }
  };

  useEffect(() => {
    getNotHandledNumber();
  }, []);

  return (
    <div
      className="icon-box bg-color-6 d-block mt-3"
      style={{
        background: "#FEE9ED",
        width: "33%",
        padding: "20px",
        margin: "15px 0 !important",
      }}>
      <div className="content text-center color-6">
        <h5 className="title-box fs-17 font-w500">Unhandled Issue Logs</h5>
        <div
          className="excellencetheme-counter fs-18 font-wb"
          style={{ fontWeight: "bold", color: "#F7284A" }}>
          <span
            className="number"
            data-from="0"
            data-to="309"
            data-speed="2500"
            data-inviewport="yes">
            <CountUp
              start={0}
              end={notHandledNumber ? notHandledNumber.total_p : "..."}
            />
          </span>
        </div>
      </div>
    </div>
  );
}
